<template>
  <InputWithInfo :label="label" :info-text="text" :info-title="title">
    <slot></slot>
  </InputWithInfo>
</template>

<script setup>
import { defineProps } from 'vue'
import InputWithInfo from '@/components/inputs/InputWithInfo.vue'
import { useMarketDependentValue } from '@/composables/markets'

const props = defineProps({
  labelDefault: {
    type: String,
    required: true,
  },
  labelMarkets: {
    type: Object,
    default() {
      return {}
    },
  },
  market: {
    type: String,
    default: null,
  },
  textDefault: {
    type: String,
    required: true,
  },
  textMarkets: {
    type: Object,
    default() {
      return {}
    },
  },
  titleDefault: {
    type: String,
    required: true,
  },
  titleMarkets: {
    type: Object,
    default() {
      return {}
    },
  },
})

const { marketValue: label } = useMarketDependentValue(
  props.market,
  props.labelMarkets,
  props.labelDefault,
)

const { marketValue: text } = useMarketDependentValue(
  props.market,
  props.textMarkets,
  props.textDefault,
)

const { marketValue: title } = useMarketDependentValue(
  props.market,
  props.titleMarkets,
  props.titleDefault,
)
</script>
